import React, { useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { auth } from "./firebase";
import { Cherry } from "lucide-react";

const GOLD = "#C9A15A";
const GOLD_LIGHT = "#E7C888";
const BG = "#0E0B08";
const PANEL = "#1D1712";
const PANEL_2 = "#2A2118";
const BORDER = "#3D3122";
const RED = "#C15B4A";
const GREEN = "#5FA772";
const TEXT_MUTED = "#B3A48D";

const inputStyle = {
  width: "100%",
  background: PANEL_2,
  border: `1px solid ${BORDER}`,
  borderRadius: 10,
  padding: "12px 14px",
  color: "#F4EFE6",
  fontSize: 15,
  outline: "none",
  boxSizing: "border-box",
};

export default function AuthScreen({ logoDataUri }) {
  const [modo, setModo] = useState("login"); // login | registro
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const traducirError = (code) => {
    const map = {
      "auth/invalid-email": "Ese correo no parece válido.",
      "auth/user-not-found": "No existe una cuenta con ese correo.",
      "auth/wrong-password": "Contraseña incorrecta.",
      "auth/invalid-credential": "Correo o contraseña incorrectos.",
      "auth/email-already-in-use": "Ya existe una cuenta con ese correo. Inicia sesión.",
      "auth/weak-password": "Tu contraseña debe tener al menos 6 caracteres.",
      "auth/missing-password": "Escribe una contraseña.",
    };
    return map[code] || "Algo salió mal. Intenta de nuevo.";
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setMensaje("");
    if (!email || !password) return;
    setCargando(true);
    try {
      if (modo === "login") {
        await signInWithEmailAndPassword(auth, email.trim(), password);
      } else {
        await createUserWithEmailAndPassword(auth, email.trim(), password);
      }
    } catch (err) {
      setError(traducirError(err.code));
    } finally {
      setCargando(false);
    }
  };

  const recuperar = async () => {
    setError("");
    setMensaje("");
    if (!email) {
      setError("Escribe tu correo arriba y presiona de nuevo.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setMensaje("Te enviamos un correo para restablecer tu contraseña.");
    } catch (err) {
      setError(traducirError(err.code));
    }
  };

  return (
    <div style={{ background: BG, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Inter','Segoe UI',sans-serif" }}>
      <div style={{ width: "100%", maxWidth: 380, background: PANEL, border: `1px solid ${BORDER}`, borderRadius: 20, padding: 28 }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 22 }}>
          {logoDataUri ? (
            <img src={logoDataUri} alt="PP Cacao" style={{ width: 84, height: 84, objectFit: "contain", marginBottom: 8 }} />
          ) : (
            <Cherry size={40} color={GOLD_LIGHT} />
          )}
          <div style={{ fontWeight: 800, fontSize: 19, color: "#F4EFE6", marginTop: 4 }}>PP Cacao</div>
          <div style={{ fontSize: 11, color: TEXT_MUTED, letterSpacing: 0.5 }}>QUE NUNCA TE FALTE TU CACAITO</div>
        </div>

        <div style={{ display: "flex", background: PANEL_2, borderRadius: 10, padding: 4, marginBottom: 18 }}>
          <button
            onClick={() => { setModo("login"); setError(""); setMensaje(""); }}
            style={{ flex: 1, padding: "8px 0", borderRadius: 8, border: "none", cursor: "pointer", fontWeight: 700, fontSize: 13, background: modo === "login" ? GOLD : "transparent", color: modo === "login" ? "#1A140C" : TEXT_MUTED }}
          >
            Iniciar sesión
          </button>
          <button
            onClick={() => { setModo("registro"); setError(""); setMensaje(""); }}
            style={{ flex: 1, padding: "8px 0", borderRadius: 8, border: "none", cursor: "pointer", fontWeight: 700, fontSize: 13, background: modo === "registro" ? GOLD : "transparent", color: modo === "registro" ? "#1A140C" : TEXT_MUTED }}
          >
            Crear cuenta
          </button>
        </div>

        <form onSubmit={submit}>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: "block", fontSize: 12, color: TEXT_MUTED, marginBottom: 6, fontWeight: 600 }}>Correo</label>
            <input type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} placeholder="tucorreo@ejemplo.com" />
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={{ display: "block", fontSize: 12, color: TEXT_MUTED, marginBottom: 6, fontWeight: 600 }}>Contraseña</label>
            <input type="password" autoComplete={modo === "login" ? "current-password" : "new-password"} value={password} onChange={(e) => setPassword(e.target.value)} style={inputStyle} placeholder="Mínimo 6 caracteres" />
          </div>

          {modo === "login" && (
            <div style={{ textAlign: "right", marginBottom: 14 }}>
              <button type="button" onClick={recuperar} style={{ background: "none", border: "none", color: GOLD_LIGHT, fontSize: 12, cursor: "pointer", padding: 0 }}>
                ¿Olvidaste tu contraseña?
              </button>
            </div>
          )}

          {error && <div style={{ background: `${RED}22`, border: `1px solid ${RED}55`, color: "#F4B7AC", fontSize: 13, borderRadius: 8, padding: "8px 10px", marginBottom: 14 }}>{error}</div>}
          {mensaje && <div style={{ background: `${GREEN}22`, border: `1px solid ${GREEN}55`, color: "#BFE3CC", fontSize: 13, borderRadius: 8, padding: "8px 10px", marginBottom: 14 }}>{mensaje}</div>}

          <button
            type="submit"
            disabled={cargando}
            style={{ width: "100%", background: cargando ? "#4a3f2c" : GOLD, color: "#1A140C", border: "none", borderRadius: 10, padding: "12px 16px", fontWeight: 700, fontSize: 15, cursor: cargando ? "not-allowed" : "pointer" }}
          >
            {cargando ? "Un momento…" : modo === "login" ? "Entrar" : "Crear mi cuenta"}
          </button>
        </form>

        <div style={{ textAlign: "center", fontSize: 11, color: TEXT_MUTED, marginTop: 18, opacity: 0.8 }}>
          Usa el mismo correo y contraseña en tu celular y en tu computadora para ver la misma información en ambos.
        </div>
      </div>
    </div>
  );
}
